/**
 * Zamowienia z B2B - usluga API (panel admina, TYLKO PODGLAD zamowien z b2b.sfd.pl).
 * Wszystko @require_admin po stronie backendu (backend/api/sfd_zamowienia.py).
 *
 * Odpowiedzi ida przez success_response {success, data, message} - funkcje zwracaja
 * odpakowane `data`. Bledy: interceptor z api.js rzuca Error z `status`, `errorCode`, `data`.
 *
 * Trasy: GET /sfd-zamowienia (lista), GET /sfd-zamowienia/podsumowanie, POST /sfd-zamowienia/odswiez
 * (202 + sync_id), GET /sfd-zamowienia/odswiez/status/<id>, GET /sfd-zamowienia/<id> (naglowek + pozycje;
 * pierwszy raz idzie do portalu - apiLong).
 */
import api, { apiLong } from './api';

const odpakuj = (response) => response?.data?.data ?? response?.data;

export const sfdZamowieniaService = {
  /**
   * GET /sfd-zamowienia?sklep_id&status&od&do&szukaj&page&limit
   * -> {wiersze: [{id, zrodlo_id, numer, status: {kod, etykieta}, status_dostawy, status_platnosci, data,
   *     data_oczekiwana, dostawa, netto, brutto, opis, adres, sklep|null, ma_pozycje}], razem, strona, na_strone, zakres}
   */
  async lista(params = {}) {
    const response = await api.get('/sfd-zamowienia', { params });
    return odpakuj(response);
  },

  /**
   * GET /sfd-zamowienia/podsumowanie?od&do
   * -> {zakres, razem: {liczba, brutto, netto}, per_sklep: [{sklep_id, nazwa, liczba, brutto}],
   *     statusy: [{kod, etykieta, liczba}], ostatnia_synchronizacja, sync_w_toku_id, naglowki_do_pobrania,
   *     skonfigurowane, legenda}
   */
  async podsumowanie(params = {}) {
    const response = await api.get('/sfd-zamowienia/podsumowanie', { params });
    return odpakuj(response);
  },

  /** POST /sfd-zamowienia/odswiez body {tryb: 'biezace'|'pelna_historia'} -> 202 {sync_id, status: 'w_toku', tryb} */
  async odswiez(tryb = 'biezace') {
    const response = await apiLong.post('/sfd-zamowienia/odswiez', { tryb });
    return odpakuj(response);
  },

  /** GET /sfd-zamowienia/odswiez/status/<id> -> {status: 'w_toku'|'ok'|'blad', stron, pobrano, nowych, naglowki_pobrane, naglowki_do_pobrania, komunikat} */
  async statusOdswiezania(syncId) {
    const response = await api.get(`/sfd-zamowienia/odswiez/status/${syncId}`, { silent: true });
    return odpakuj(response);
  },

  /** GET /sfd-zamowienia/<id> -> naglowek + pozycje [{lp, kod_sfd, kod, nazwa, ilosc, cena_netto, vat, netto, brutto, jednostka}] */
  async szczegoly(id) {
    const response = await apiLong.get(`/sfd-zamowienia/${id}`);
    return odpakuj(response);
  },
};

export default sfdZamowieniaService;
